import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubHeaderService } from 'src/app/shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { View } from '../../../../shared/store/view/types';
import { ViewService } from '../../../../shared/store/view/views.service';
import { InsuranceClaimService } from 'src/app/shared/store/insurance-claim/insurance-claim.service';
import { InsuranceClaimModel } from 'src/app/shared/store/insurance-claim/types';

@UntilDestroy()
@Component({
  selector: 'app-insurance-claim-details',
  templateUrl: './insurance-claim-details.component.html',
  styleUrl: './insurance-claim-details.component.scss',
  standalone: false,
})
export class InsuranceClaimDetailsComponent implements OnInit, OnDestroy {
  insuranceClaimUniqueId: string;
  insuranceClaim$: Observable<InsuranceClaimModel>;
  insuranceClaimId: number;
  view$: Observable<View>;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.insuranceClaim$ = this.insuranceClaimService.getByUniqueId.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.insuranceClaimUniqueId = this.route.snapshot.params['uniqueId'];
    this.insuranceClaimService.getByUniqueId.call(this.insuranceClaimUniqueId);

    this.insuranceClaim$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@insuranceClaimDetails', x.name);
        this.insuranceClaimId = x.id;
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'insuranceClaimEdit') {
          this.router.navigate([
            'Insurance/InsuranceClaims/Edit/',
            this.insuranceClaimUniqueId,
          ]);
        }
        if (x == 'insuranceClaimRefreshDocuments') {
          this.generateDocuments();
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.insuranceClaimService.getByUniqueId.reset();
    this.insuranceClaimService.generateDocuments.reset();
    this.breadcrumbService.set('@insuranceClaimDetails', ' ');
  }

  generateDocuments(): void {
    if (!this.insuranceClaimId) return;
    this.insuranceClaimService.generateDocuments.call(this.insuranceClaimId);
  }
}
